import { onlineSteps } from '@/mocks/content';

export default function OnlineSection() {
  return (
    <section id="online" className="w-full scroll-mt-20 bg-[#fffbf5] py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-3xl">
          <span className="text-sm font-medium text-orange-600">在线播放</span>
          <h2 className="font-heading mt-2 text-2xl md:text-4xl font-bold text-stone-900">
            在线看：从确定版本到确认片源的五步
          </h2>
          <p className="mt-4 text-stone-600 leading-relaxed">
            在线播放省去下载等待，最适合想先看看、或临时观看的情况。按下面的顺序一步步来，
            能少踩很多坑，也更容易找到匹配你需求的版本。
          </p>
        </div>

        <ol className="mt-9 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {onlineSteps.map((step, i) => (
            <li
              key={step.no}
              className={`relative bg-white border border-stone-200 rounded-xl p-6 ${
                i === 0 ? 'md:col-span-2 lg:col-span-1' : ''
              }`}
            >
              <div className="flex items-center gap-3">
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-stone-900 text-white font-heading font-bold">
                  {step.no}
                </span>
                <h3 className="font-heading text-base font-semibold text-stone-900">{step.title}</h3>
              </div>
              <p className="mt-4 text-sm text-stone-600 leading-relaxed">{step.desc}</p>
            </li>
          ))}
        </ol>

        <div className="mt-8 flex flex-col sm:flex-row items-start gap-3 bg-orange-50 border border-orange-200 rounded-xl p-5">
          <i className="ri-error-warning-line text-orange-500 text-xl mt-0.5" aria-hidden="true"></i>
          <p className="text-sm text-stone-700 leading-relaxed">
            遇到要求下载陌生播放器、输入账号密码，或页面反复弹出广告的站点，请立即关闭。
            优先选择有正规授权、口碑清晰的平台，是观看体验与账号安全都最有保障的方式。
          </p>
        </div>
      </div>
    </section>
  );
}